<div *ngIf="notifications.length != 0" class="notifications-container">
  <rt-notification
    (closing)="this.clearNotification(notification)"
    *ngFor="let notification of notifications"
    [notification]="notification"
  ></rt-notification>
</div>
